(function () {
  /* LEVANRA cart-drawer enhancements (ported from the "lip" theme). */
  if (window.Shopify && Shopify.designMode) return;

  var CHECK_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var FALLBACK_HANDLE = 'cozy-v-neck-perfect-1-4-zip';

  function currentProductUrl() {
    var p = location.pathname || '';
    if (p.indexOf('/products/') !== -1) return p + (location.search || '');
    return '/products/' + FALLBACK_HANDLE;
  }

  function isContinueLink(a) {
    if (!a || !a.closest) return false;
    if (!a.closest('cart-drawer')) return false;
    if (!a.closest('.drawer__inner-empty, .cart-drawer__warnings, .cart-drawer__empty-content')) return false;
    return /continue shopping/i.test(a.textContent || '');
  }

  function continueLink(drawer) {
    try {
      var url = currentProductUrl();
      var links = drawer.querySelectorAll('a.button, .cart__warnings a, .drawer__inner-empty a, .cart-drawer__warnings a');
      links.forEach(function (a) {
        if (/continue shopping/i.test(a.textContent)) a.setAttribute('href', url);
      });
    } catch (e) {}
  }

  /* Bulletproof: even if a re-render restores the default href, intercept the click. */
  function onContinueClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!isContinueLink(a)) return;
    e.preventDefault();
    window.location.href = currentProductUrl();
  }

  function banner(inner) {
    var b = inner.querySelector('.lv-cart-ship');
    if (!b) {
      var header = inner.querySelector('.drawer__header');
      b = document.createElement('div');
      b.className = 'lv-cart-ship';
      b.innerHTML = '<span><strong>Free shipping</strong> has been applied</span><span class="lv-cart-ship__ck" aria-hidden="true">' + CHECK_SVG + '</span>';
      if (header) header.insertAdjacentElement('afterend', b); else inner.insertBefore(b, inner.firstChild);
    }
    if (!inner.querySelector('.lv-cart-divider')) {
      var line = document.createElement('div'); line.className = 'lv-cart-divider';
      b.insertAdjacentElement('afterend', line);
    }
  }

  function movePrice(row) {
    try {
      var details = row.querySelector('.cart-item__details');
      var priceWrap = row.querySelector('.cart-item__price-wrapper');
      if (!details || !priceWrap || details.contains(priceWrap)) return;
      priceWrap.classList.add('lv-item-price');
      var dl = details.querySelector('dl');
      if (dl) dl.insertAdjacentElement('afterend', priceWrap);
      else { var title = details.querySelector('.cart-item__title'); if (title) title.insertAdjacentElement('afterend', priceWrap); else details.appendChild(priceWrap); }
    } catch (e) {}
  }

  function removeText(row) {
    try {
      var rb = row.querySelector('cart-remove-button');
      if (!rb || rb.querySelector('.lv-remove-text')) return;
      var link = rb.querySelector('a, button') || rb;
      var t = document.createElement('span'); t.className = 'lv-remove-text'; t.textContent = 'remove';
      link.appendChild(t);
    } catch (e) {}
  }

  /* Show each line's green discount badge (e.g. "2 item Deal") only when the cart
     qualifies for a multi-item deal -- i.e. the cart holds 2+ units in total
     (whether that's one line at qty 2+, or two separate variants at qty 1 each).
     A single unit in the whole cart hides the badge, since the single-item sale
     is already shown via the struck price. */
  function lineDiscountVisibility(drawer) {
    var rows = drawer.querySelectorAll('.cart-item');
    var totalQty = 0;
    rows.forEach(function (row) {
      try {
        var input = row.querySelector('input.quantity__input, input[name="updates[]"], input[type=number]');
        totalQty += input ? (parseInt(input.value, 10) || 1) : 1;
      } catch (e) {}
    });
    var show = totalQty > 1;
    rows.forEach(function (row) {
      try {
        var list = row.querySelector('.cart-item__details ul.discounts') || row.querySelector('.cart-item__details .discounts');
        if (list) list.style.display = show ? '' : 'none';
      } catch (e) {}
    });
  }

  function footer(drawer) {
    var f = drawer.querySelector('.drawer__footer');
    if (!f) return;
    var totals = f.querySelector('.totals');
    var ctas = f.querySelector('.cart__ctas');
    var taxNote = f.querySelector('.tax-note');
    if (totals && !f.querySelector('.lv-cart-urgency')) {
      var u = document.createElement('div'); u.className = 'lv-cart-urgency'; u.textContent = "don't wait, sellout risk";
      totals.insertAdjacentElement('afterend', u);
    }
    if (taxNote && ctas && (taxNote.compareDocumentPosition(ctas) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      f.appendChild(taxNote);
    }
    var tv = f.querySelector('.totals__total-value');
    if (tv) { var stripped = tv.textContent.replace(/\s*[A-Za-z]{3}\s*$/, ''); if (tv.textContent.trim() !== stripped.trim()) tv.textContent = stripped; }
  }

  function qty(drawer) {
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      try {
        var wrap = row.querySelector('.cart-item__quantity-wrapper') || row.querySelector('.cart-item__quantity');
        if (!wrap || wrap.querySelector('.lv-qty')) return;
        var input = row.querySelector('input.quantity__input, input[name="updates[]"], input[type=number]');
        var cur = input ? (parseInt(input.value, 10) || 1) : 1;
        var line = (input && input.getAttribute('data-index')) || (row.id.match(/(\d+)$/) || [])[1];
        if (!line) return;
        var sel = document.createElement('select'); sel.className = 'lv-qty'; sel.setAttribute('aria-label', 'Quantity');
        var max = Math.max(10, cur);
        for (var i = 1; i <= max; i++) { var o = document.createElement('option'); o.value = i; o.textContent = 'QTY: ' + i; if (i === cur) o.selected = true; sel.appendChild(o); }
        sel.addEventListener('change', function () { changeQty(line, sel.value, sel); });
        var stepper = wrap.querySelector('.quantity-popover-container') || wrap.querySelector('.quantity');
        if (stepper) stepper.style.display = 'none';
        wrap.insertBefore(sel, wrap.firstChild);
      } catch (e) {}
    });
  }

  function changeQty(line, quantity, sel) {
    var drawer = document.querySelector('cart-drawer');
    if (sel) sel.disabled = true;
    var body = { line: Number(line), quantity: Number(quantity), sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else { location.reload(); }
      }).catch(function () { location.reload(); });
  }

  var scheduled = false;
  function enhance() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try { continueLink(drawer); } catch (e) {}
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    if (!drawer.querySelector('.cart-item')) return;
    try { banner(inner); } catch (e) {}
    try { drawer.querySelectorAll('.cart-item').forEach(movePrice); } catch (e) {}
    try { drawer.querySelectorAll('.cart-item').forEach(removeText); } catch (e) {}
    try { lineDiscountVisibility(drawer); } catch (e) {}
    try { qty(drawer); } catch (e) {}
    try { footer(drawer); } catch (e) {}
  }
  function schedule() { if (scheduled) return; scheduled = true; setTimeout(function () { scheduled = false; enhance(); }, 0); }

  function init() {
    enhance();
    if (document.body.dataset.lvCartObs !== '1') {
      document.body.dataset.lvCartObs = '1';
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', onContinueClick, true);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
